var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.formatClass,style:({'font-size': _vm.size})},[(_vm.sign)?[_vm._v(_vm._s(_vm.rateSign))]:_vm._e(),_vm._v(_vm._s(_vm.formatNum)),(_vm.mark)?[_vm._v("%")]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }